import { Injectable } from '@angular/core';
import { PopoverController, ToastController } from '@ionic/angular';
import { TicketPage } from 'src/app/pages/shop/ticket/ticket.page';
import { UserMembershipProvider } from 'src/app/providers/UserMembershipProvider';

@Injectable({
  providedIn: 'root'
})
export class VentaService {

  constructor(
    private toastController: ToastController,
    private userMembershipProvider: UserMembershipProvider,
    private popoverController: PopoverController,
  ) { }

  async setPendientPayMembership(id_user_membresia,dataTicket){
    const toast = await this.toastController.create({
      message:'Estamos procesando el pago domiciliado de la membresía, te avisaremos cuando se complete',
    });
    toast.present();
    setTimeout(async () => {
      let mem = await this.userMembershipProvider.show(id_user_membresia);
      if(!mem.data || mem.data.estatus_pago=='pendiente' || mem.data.estatus_pago=='fallido'){
        toast.message ="El pago de la membresía fallo, quedará marcada como pendiente hasta que el pago se complete o bien puedes confirmalo desde la información del atleta";
        toast.color = "warning";
        toast.buttons=[{
          text:'ok'
        }]
      }else if (mem.data.estatus_pago=='pagado'){
        toast.message ="El pago fue completado con éxito";
        toast.color = "success"
        toast.buttons=[{
          text:'Ver ticket',
          handler:()=>{
            this.showTicket(dataTicket);
          }
        }]
      }
    }, 15000);
  }

  async showTicket(data){
    const popover = await this.popoverController.create({
      component:TicketPage,
      cssClass:  'popoverTicket',
      translucent: true,
      componentProps: { data: data}
    });
    await popover.present();
  }


}
